export default "https://cdn-static.gokick.com/assets/e031f09406d9a12f4f19fb28fc50e3428375be91/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";